<template>
  <div class="message" :style="{ backgroundColor: message.dominant_color }">
    <div class="message__container">
      <div class="message__author" :style="{ borderColor: message.dominant_color }">
        <img :src="message.author.thumbnail_url">
      </div>
      <!-- TODO: use message.is_archivable -->
      <div class="message__header">
        <slot name="header" />
      </div>

      <div class="message__header__menu">
        <MoreVertSvg
          v-if="hasActions"
          inverse
          size="24px"
          class="message__header__trigger"
          @click.native="isActionMenuOpen = !isActionMenuOpen"
        />
        <LoaderDualRings
          v-show="isArchiving"
          class="message__header__loader"
          :total-size="2"
          :internal-ring-size="2.2"
          internal-ring-color="black"
          :external-ring-size="3"
          external-ring-color="black"
        />
        <ul v-show="isActionMenuOpen" class="message__header__actions">
          <li
            v-for="action in actions"
            :key="action.text"
            class="message__header__action"
            @click="trigger(action.method)"
          >
            {{ action.text }}
          </li>
        </ul>
        <ModalCancelReceipt
          v-if="isCancelModalOpen"
          :is-cancelling="isCancelling"
          @confirmed="cancel"
          @close="isCancelModalOpen = false"
        />
      </div>

      <div class="message__content">
        <slot name="content" />
      </div>
      <div v-if="$slots.footer" class="message__footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import LoaderDualRings from '../../loaders/DualRings'

import MoreVertSvg from '../../../assets/images/icons/more_vert.svg'

import ModalCancelReceipt from './ModalCancelReceipt'

export default {
  components: { LoaderDualRings, MoreVertSvg, ModalCancelReceipt },
  props: {
    isArchived: {
      type: Boolean,
      default: false,
    },
    message: {
      type: Object,
      required: true,
      validator: message =>
        message.hasOwnProperty('author') &&
        message.hasOwnProperty('category') &&
        // message.hasOwnProperty('is_archivable') && // not available in archived messages
        message.hasOwnProperty('dominant_color') &&
        message.author.hasOwnProperty('thumbnail_url') &&
        true
      ,
    },
  },
  data: () => ({
    isArchiving: false,
    isCancelling: false,
    isActionMenuOpen: false,
    isCancelModalOpen: false,
  }),
  computed: {
    isReceipt () {
      return this.message.category.endsWith('Receipt')
    },
    actions () {
      if (this.isArchived) { return [] }

      const list = []
      if (this.message.category === 'DeclaredReceipt') {
        list.push({
          text: 'Annuler le ticket',
          method: 'askCancelConfirmation',
        })
      }
      if (this.message.is_archivable) {
        list.push({
          text: this.isReceipt ? 'Archiver' : 'Supprimer ce message',
          method: 'archive',
        })
      }
      return list
    },
    hasActions () {
      return this.actions.length !== 0
    },

    loading () {
      return this.isArchiving || this.isCancelling
    },
  },
  methods: {
    trigger (method) {
      this[method]()
    },
    async archive () {
      if (this.loading) { return }

      this.isArchiving = true
      await this.archiveMessage(this.message)
      this.isArchiving = false
    },
    async askCancelConfirmation () {
      if (this.loading) { return }

      this.isActionMenuOpen = false
      this.isCancelModalOpen = true
    },

    async cancel () {
      if (this.loading) { return }

      this.isCancelling = true
      await this.cancelReceipt(this.message.data.receipt_uuid)
      await this.reset()
      this.isCancelling = false
    },

    ...mapActions('timeline', ['archiveMessage', 'cancelReceipt', 'reset']),
  },
}
</script>

<style lang="scss" scoped>
@import '~assets/css/mixins';
@import '~assets/css/variables';

$thumbnail-size: 40px;
$thumbnail-translation: -5px;

$menu-width: 3rem;

.message {
  position: relative;
  border-radius: 20px 10px 10px 5px;
  @include font-family__oswald;
  color: $color-text-gray-dark;
}
.message__container {
  background-color: white;
  border-radius: 0 5px 5px 0;
  margin-left: 6px;
}
.message__author {
  position: absolute;
  top: 0;
  left: $thumbnail-translation;
  width:  $thumbnail-size;
  height: $thumbnail-size;
  border-radius: 50%;
  border-style: solid;
  border-width: 1px;
}
.message__header {
  height: $thumbnail-size;
  padding-left: $thumbnail-size + $thumbnail-translation;
  padding-right: $menu-width;
  display: flex;
  align-items: center;
  color: $color-text-black;
}
.message__header__menu {
  position: absolute;
  width: $menu-width;
  height: $thumbnail-size;
  top: 0;
  right: 0;
}
.message__header__trigger {
  cursor: pointer;
  @include abso-center;
}
.message__header__loader {
  @include abso-center;
}
.message__header__actions {
  padding: 0;
  margin: 0;
  position: absolute;
  right: 10px;
  top: $thumbnail-size;
  list-style: none;
  white-space: nowrap;
  background-color: white;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.5);
}
.message__header__action {
  padding: 0.5rem 1rem;
  cursor: pointer;
}
.message__footer {
  padding: 1rem;
  text-align: center;
}
</style>
